<div class="modal" [class.modal--upload-started]="isUploadInProgress">
  <div class="modal-dialog" [class.modal-dialog--upload-started]="isUploadInProgress">
    <div class="modal-content" [class.modal-content--upload-started]="isUploadInProgress">
      <app-modal-loading-screen *ngIf="isDownloadingTemplate">Preparing Template</app-modal-loading-screen>

      <div class="modal-header">
        <h4 class="pagetitle">Create PRF from File: {{ prfyear }}</h4>
        <span
          class="table-material-icons close-button"
          (click)="requestClose()"
          (keydown)="requestClose()"
          >close</span
        >
      </div>
      <div class="modal-body">
        <ng-container *ngIf="!isUploadInProgress; else uploadProgress">
        <a
          class="download-link"
          href="javascript:void(0)"
          (click)="downloadPrfTemplate()"
          (keydown)="downloadPrfTemplate()"
        >
          <mat-icon>download</mat-icon>
          <span>Download PRF Template</span>
        </a>

        <div class="upload-divider"></div>

        <div class="upload-panel">
          <div class="upload-panel__icon">
            <mat-icon>upload</mat-icon>
          </div>

          <h5 class="upload-panel__title">Upload PRF Template</h5>
          <p class="upload-panel__subtitle">Select an Excel (.xlsx) file to get started</p>

          <button class="upload-panel__button" (click)="fileInputForModal.click()">
            <mat-icon>upload</mat-icon>
            <span>Upload PRF Template</span>
          </button>

          <input
            type="file"
            #fileInputForModal
            (change)="onFileSelected($event)"
            style="display:none"
            accept=".xlsx,.xls"
          />

          <p class="selected-file" *ngIf="selectedFile">
            Selected file: {{ selectedFile.name }}
          </p>
        </div>

        <p class="error-message" *ngIf="invalidFileMessage">
          {{ invalidFileMessage }}
        </p>

        <div class="modal-footer">
          <app-button
            size="medium"
            buttonType="secondary"
            (click)="activeModal.dismiss('Cross click')"
            (keydown)="activeModal.dismiss('Cross click')"
          >
            Cancel
          </app-button>
          <app-button
            size="medium"
            buttonType="primary"
            class="select-button"
            [disabled]="!selectedFile"
            (click)="uploadFile()"
            (keydown)="uploadFile()"
          >
            Upload
          </app-button>
        </div>
        </ng-container>
        <ng-template #uploadProgress>
          <div class="upload-progress-wrapper">
            <prf-template-uploader [operatorInput]="operatorInput"></prf-template-uploader>
            <div class="close-confirm-overlay" *ngIf="showCloseConfirm">
              <div class="close-confirm-box">
                <p class="close-confirm-message">Upload is in progress. Are you sure you want to close?</p>
                <div class="close-confirm-actions">
                  <app-button size="medium" buttonType="secondary" (click)="cancelClose()" (keydown.enter)="cancelClose()">No, Continue</app-button>
                  <app-button size="medium" buttonType="error" (click)="confirmClose()" (keydown.enter)="confirmClose()">Yes, Close</app-button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>